import { createRestSlice } from "./restSlice";

export type DemoHighlight = {
  label: string;
  value: string;
  sublabel?: string;
};

export type DemoFeaturedSession = {
  sessionId: string;
  caption?: string;
};

export type DemoCta = {
  label: string;
  url: string;
};

/** Mirrors the API's `toDemoShareResponse` (admin-facing) shape. */
export type DemoShare = {
  id: string;
  organizationId: string;
  agentId: string;
  slug: string;
  title: string;
  subtitle: string | null;
  intro: string | null;
  highlights: DemoHighlight[] | null;
  featuredSessions: DemoFeaturedSession[] | null;
  accentColor: string | null;
  ctas: DemoCta[] | null;
  webCallEnabled: boolean;
  phoneCallEnabled: boolean;
  callEnvironment: string | null;
  hasPassword: boolean;
  isActive: boolean;
  expiresAt: string | null;
  viewCount: number;
  lastViewedAt: string | null;
  publicUrl: string;
  createdAt: string;
  updatedAt: string;
  /** Plaintext password, returned ONCE by create / regenerate-password. Transient — never persisted. */
  generatedPassword?: string;
};

/** Write payload for create/update — `password` is write-only and never returned. */
export type DemoShareInput = Partial<DemoShare> & { password?: string };

const demoShareSlice = createRestSlice<DemoShare>("demoShares", "/v1/demo-shares");

export const demoShareReducer = demoShareSlice.reducer;
export const demoShareActions = demoShareSlice.actions;
